import React from 'react';
import { MdClose } from 'react-icons/md';
import styles from './AuditTrail.module.css';

const AuditDetailsPanel = ({ slidingPanel, onClose }) => {
    const formatTimestamp = (timestamp) => {
        return new Date(timestamp).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    };

    if (!slidingPanel.isOpen) return null;

    return (
        <>
            <div className={styles.overlay} onClick={onClose}></div>
            <div className={styles.slidingPanel}>
                <div className={styles.panelHeader}>
                    <h2>Audit Details</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        <MdClose />
                    </button>
                </div>
                <div className={styles.panelContent}>
                    {slidingPanel.loading ? (
                        <div className={styles.panelLoading}>
                            <div className={styles.spinner}></div>
                            <p>Loading details...</p>
                        </div>
                    ) : slidingPanel.data ? (
                        <>
                            <div className={styles.auditInfo}>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>User Name:</span>
                                    <span className={styles.infoValue}>{slidingPanel.data.full_name || '-'}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>Role:</span>
                                    <span className={styles.infoValue}>{slidingPanel.data.role_name || '-'}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>Module:</span>
                                    <span className={styles.infoValue}>{slidingPanel.data.module_name || '-'}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>Action Type:</span>
                                    <span className={styles.actionBadgePanel}>{slidingPanel.data.action_type || '-'}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>Timestamp:</span>
                                    <span className={styles.infoValue}>{formatTimestamp(slidingPanel.data.timestamp)}</span>
                                </div>
                                <div className={`${styles.infoRow} ${styles.remarkRow}`}>
                                    <span className={styles.infoLabel}>Remark:</span>
                                    <span className={styles.infoValue}>{slidingPanel.data.remark || '-'}</span>
                                </div>
                            </div>

                            {slidingPanel.data.diff && slidingPanel.data.diff.length > 0 ? (
                                <div className={styles.changesContainer}>
                                    <h3 className={styles.changesTitle}>Changes Made</h3>
                                    {slidingPanel.data.diff.map((change, index) => (
                                        <div key={index} className={styles.changeItem}>
                                            <h4 className={styles.fieldName}>{change.field_name || '-'}</h4>
                                            <div className={styles.valueComparison}>
                                                <div className={styles.oldValue}>
                                                    <span className={styles.valueLabel}>Old Value:</span>
                                                    <span className={styles.valueText}>{change.old_value || '-'}</span>
                                                </div>
                                                <div className={styles.arrow}>→</div>
                                                <div className={styles.newValue}>
                                                    <span className={styles.valueLabel}>New Value:</span>
                                                    <span className={styles.valueText}>{change.new_value || '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className={styles.noChanges}>
                                    <p>No changes found for this audit log</p>
                                </div>
                            )}
                        </>
                    ) : (
                        <div className={styles.noChanges}>
                            <p>No data available</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default AuditDetailsPanel;